import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ServersMaster = () => {
  const [servers, setServers] = useState([]);
  const [formData, setFormData] = useState({ serverName: '', id: null });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Fetch all servers
  useEffect(() => {
    fetchServers();
  }, []);

  const fetchServers = async () => {
    try {
      const response = await axios.get('https://astrovidhya.in/api/servers');
      setServers(response.data);
    } catch (error) {
      console.error('Error fetching servers:', error);
      setError('Failed to fetch servers.');
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, serverName: e.target.value });
  };

  // Handle create/update server
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.serverName.trim()) {
      setError('❌ Server name is required.');
      return;
    }

    const method = formData.id ? 'PUT' : 'POST';
    const url = formData.id
      ? `https://astrovidhya.in/api/servers/${formData.id}`
      : 'https://astrovidhya.in/api/servers';

    try {
      const response = await axios({
        method,
        url,
        data: { serverName: formData.serverName },
        headers: { "Content-Type": "application/json" },
      });

      if (method === 'POST') {
        setServers([...servers, response.data.server]);
      } else {
        setServers(servers.map((server) =>
          server._id === response.data.server._id ? response.data.server : server
        ));
      }

      setMessage('✅ Server saved successfully.');
      resetForm();
    } catch (error) {
      console.error('❌ Error saving server:', error);
      setError(error.response?.data?.message || '❌ Failed to save server.');
    }
  };

  // Handle edit server
  const handleEdit = (server) => {
    setFormData({ serverName: server.serverName, id: server._id });
    setMessage('');
    setError('');
  };

  // Handle delete server
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this server?')) {
      try {
        await axios.delete(`https://astrovidhya.in/api/servers/${id}`);
        setServers(servers.filter((server) => server._id !== id));
        setMessage('✅ Server deleted successfully.');
      } catch (error) {
        console.error('❌ Error deleting server:', error);
        setError('❌ Failed to delete server.');
      }
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({ serverName: '', id: null });
    setMessage('');
    setError('');
  };

  return (
    <div className="flex flex-row gap-6 p-6">
      {/* Left Panel: Input Form (1/3 Width) */}
      <div className="w-1/3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold mb-4">Manage Server</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700">Server Name</label>
            <input
              type="text"
              name="serverName"
              value={formData.serverName}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter server name"
              maxLength={40}
            />
          </div>
          <div className="flex space-x-4 mt-4">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2"
            >
              Save
            </button>
            <button
              type="button"
              onClick={resetForm}
              className="bg-gray-500 hover:bg-gray-700 text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2"
            >
              Reset
            </button>
          </div>
        </form>
        {message && <p className="text-green-500 mt-4">{message}</p>}
        {error && <p className="text-red-500 mt-4">{error}</p>}
      </div>

      {/* Right Panel: Server List (2/3 Width) */}
      <div className="w-2/3 bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold mb-4">Server List</h2>
        <table className="table-auto w-full text-left">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2">Server Name</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {servers.map((server) => (
              <tr key={server._id} className="hover:bg-gray-50">
                <td className="px-4 py-2">{server.serverName}</td>
                <td className="px-4 py-2 flex space-x-2">
                  <button
                    onClick={() => handleEdit(server)}
                    className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded w-1/3"
                  >
                    Edit
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(server._id);
                    }}
                    className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded w-1/3"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {servers.length === 0 && (
          <p className="text-gray-500 mt-4">No servers found.</p>
        )}
      </div>
    </div>
  );
};

export default ServersMaster;
